import { createFileRoute } from "@tanstack/react-router";
import { CasesPage } from "@/components/pages/CasesPage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Cases & Results — Kentro Sistemas",
    desc: "Real results from companies using Kentro to scale support, sales and marketing with AI.",
    ogTitle: "Cases & Results — Kentro",
    ogDesc: "Companies scaling operations with generative AI and omnichannel.",
  },
  es: {
    title: "Casos y Resultados — Kentro Sistemas",
    desc: "Resultados reales de empresas que usan Kentro para escalar atención, ventas y marketing con IA.",
    ogTitle: "Casos y Resultados — Kentro",
    ogDesc: "Empresas escalando su operación con IA generativa y omnicanal.",
  },
} as const;

export const Route = createFileRoute("/$locale/cases")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/cases` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/cases` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/cases` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/cases` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/cases` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/cases` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Cases', item: `${SITE}/${loc}/cases` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/cases`,
            url: `${SITE}/${loc}/cases`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: CasesPage,
});
